import useFeatureFlags from 'common/hooks/useFeatureFlags';
import useUser from 'common/hooks/useUser';

export const useIsVenueGroupEnabled = (brandCountry: string, brandId: string) => {
  const { isEmployee, user } = useUser();
  const userId = user?.id || '';

  const {
    data: featureFlags,
    isLoading,
    isFetching,
  } = useFeatureFlags(['enable_venue_group'], {
    user_id: userId,
    is_employee: isEmployee,
    brand_id: brandId,
    country: brandCountry,
  });

  const loading = isLoading && isFetching;

  if (loading) {
    return false;
  } else {
    return featureFlags?.enable_venue_group === 'on';
  }
};
